import { ContextAction } from '$modules/onboarding/types';

export type UserState = {
  userId: string;
  username: string;
};

export const userInitial = { userId: '', username: 'Default User' };

export type UserAction =
  | { type: ContextAction.setUserName; payload: string }
  | { type: ContextAction.setUserId; payload: string };

export const userReducer = (
  state: UserState,
  action: UserAction
): UserState => {
  switch (action.type) {
    case ContextAction.setUserName:
      return { ...state, username: action.payload };
    case ContextAction.setUserId:
      return { ...state, userId: action.payload };
    default:
      return state;
  }
};
